import Head from 'next/head';
import React, { ReactNode } from 'react';
import { ErrorBoundary } from 'src/components/system';
import { chakra, Box } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import Header from './header';
import HelpButton from 'src/components/atoms/help-button';

interface AdminRouteOnboardingLayoutProps {
  children: ReactNode;
}

const AdminRouteOnboardingLayout = ({ children, ...rest }: AdminRouteOnboardingLayoutProps) => {
  const router = useRouter();
  const isSignupPage = router.pathname.includes('/onboarding/signup');

  return (
    <>
      <Head>
        <link rel="icon" type="image/png" sizes="48x48" href={'/marketplace.ico'} />
        <link rel="shortcut icon" href={'/marketplace.ico'} />
        <link rel="apple-touch-icon" sizes="48x48" href={'/marketplace.ico'} />
        <meta name="apple-mobile-web-app-title" content={'Loma Onboarding'} />
      </Head>
      <chakra.main px={0} minH="100vh" display="flex" flexDirection="column">
        <Header />
        <Box flex="1" display="flex" flexDirection="column">
          <ErrorBoundary>{children}</ErrorBoundary>
        </Box>
        {!isSignupPage && <HelpButton />}
      </chakra.main>
    </>
  );
};

export default AdminRouteOnboardingLayout;
